import './Navbar.css';
import './App.css';
import Navbar from './components/Navbar';
import Textform from './components/Textform';
import { useState, useEffect } from 'react'; // Import useEffect for initialization
import About from './components/About';
import Alert from './components/Alert';
import Textanalyzer from './components/TextAnalyzer';
import StartPage from './components/TextAnalyzer';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  // Initialize mode from localStorage or default to light mode
  const savedMode = localStorage.getItem('mode') || 'light';
  const [mode, setMode] = useState(savedMode);
  const [alert, setAlert] = useState(null);

  let showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    });

    setTimeout(() => {
      setAlert(null);
    }, 2000);
  };

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#03062b';
      showAlert("Dark Mode is Enabled", 'success');
      document.title = 'TextUtils - DarkMode';
      localStorage.setItem('mode', 'dark'); // Save mode to localStorage
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light Mode is Enabled", 'success');
      document.title = 'TextUtils - LightMode';
      localStorage.setItem('mode', 'light'); // Save mode to localStorage
    }
  };

  useEffect(() => {
    // Set initial background color based on saved mode when app loads
    if (mode === 'dark') {
      document.body.style.backgroundColor = '#03062b';
    } else {
      document.body.style.backgroundColor = 'white';
    }
  }, [mode]); // Dependency array to update the background color when mode changes

  return (
    <>
      <Router>
        <Navbar title="Text Analyzer" mode={mode} toggleMode={toggleMode} About="About" Menu="Menu" dish1="Pavbhaji" dish2="Paneer Tikka" />
        <Alert alert={alert} />

        <div className='container'>
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path='/' element={<Textanalyzer />} />
            <Route path='/about' element={<About />} />
            <Route path='/textform' element={<Textform showAlert={showAlert} heading="Enter your text here to analyze" mode={mode} />} />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
